import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Education.scss";
import College from "../../assets/images/education-section/icons8-graduation-cap-100.png";
import School from "../../assets/images/education-section/icons8-school-100.png";
import School10 from "../../assets/images/education-section/icons8-backpack-100.png";

function Education() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const educationData = [
        {
            id: 1,
            icon: College,
            degree: "Bachelor of Technology",
            specialization: "Information Technology",
            institution: "Jaypee Institute of Information Technology, Noida, UP",
            dateRange: "2019 – 2023",
            achievements: "Winner Hack-2-Connect 3.0; Finalist ApScript & CoviHack'21; 300+ DSA problems on LeetCode"
        },
        {
            id: 2,
            icon: School,
            degree: "Higher Secondary Education",
            specialization: "Science Stream",
            institution: "Bhartiya Vidhyapeeth",
            dateRange: "2017 – 2018"
        },
        {
            id: 3,
            icon: School10,
            degree: "Secondary Education",
            specialization: "General Studies",
            institution: "St Peter's College, Agra",
            dateRange: "2015 – 2016"
        }
    ];

    return (
        <Container fluid className="education-section" id="education">
            <Container>
                <Row>
                    <Col xs={12}>
                        <div className="section-header text-center">
                            <h2 className="section-title">Education</h2>
                            <p className="section-subtitle">My academic journey and learning experiences</p>
                        </div>
                    </Col>
                </Row>
                
                <Row className="g-4">
                    {educationData.map((education, index) => (
                        <Col key={education.id} lg={4} md={6} sm={12} className="education-col">
                            <Card className={`education-card ${isVisible ? 'fade-in' : ''}`} 
                                  style={{ animationDelay: `${index * 0.2}s` }}>
                                <Card.Body className="card-content">
                                    {/* Icon Section */}
                                    <div className="icon-section">
                                        <div className="education-icon">
                                            <img 
                                                src={education.icon} 
                                                alt={education.degree} 
                                                className="icon-image"
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* Content Section */}
                                    <div className="content-section">
                                        <h3 className="degree-name">{education.degree}</h3>
                                        <h4 className="specialization">{education.specialization}</h4>
                                        <div className="institution-info">
                                            <i className="fas fa-university"></i>
                                            <span>{education.institution}</span>
                                        </div>
                                        <div className="date-range">
                                            <i className="fas fa-calendar-alt"></i>
                                            <span>{education.dateRange}</span>
                                        </div>
                                        {education.achievements && (
                                            <div className="achievements">
                                                <i className="fas fa-trophy"></i>
                                                <span>{education.achievements}</span>
                                            </div>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Container>
    );
}

export default Education;
